import { defineMessages } from "@/i18n";
import en from "./en";

export const framesDatasetMessages = defineMessages("frames-dataset", en);
